import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import firebase from './../../../firebase';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const EditService = () => {
  const { id } = useParams();

  const [l, setL] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    // firebase.auth().onAuthStateChanged((user) => {
    if (id) {
      setL(true);
      firebase.firestore().collection('services').doc(id).get().then(doc => {
        if (doc) {
          let d = doc.data()
          d.id = doc.id;
          d.linkicon = d.link;
          setFormData(d)
          setL(false);
        }
      })
    } else {
      setL(false);
      toast.error('Une erreur s\'est produite.');
    }
    // })
  }, [])

  const handleChange = e => {
    let d = { ...formData };
    d[e.target.name] = e.target.value;
    setFormData(d);
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (formData && formData.title && (formData.icon || formData.linkicon) && formData.id) {
      const da = {
        icon: formData.icon || null,
        title: formData.title,
        title_en : formData.title_en || null,
        link: formData.linkicon || null,
        critereId: formData.critereId || null,
        update_At: new Date(),
        // category: formData.category ? formData.category : null
      }
      setLoading(true);
      firebase.firestore().collection('services').doc(formData.id).update(da).then((res) => {
        setLoading(false);
        toast.success('Mise à jour terminé');
      }).catch(err => {
        setLoading(false);
        toast.error('Une erreur s\'est produite.');
      })
    } else {
      toast.error('Veuillez remplir tout les champs. Soit le lien d\'icon ou l\'icone');
    }
  };

  return (
    <Card>
      <FalconCardHeader title="Edition du service" />
      {l ? <p>Chargement...</p> : (
        <Card.Body className="bg-body-tertiary">
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3 g-3">
              <Form.Group as={Col} lg={3} controlId="title">
                <Form.Label>Titre</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="titre"
                  value={formData.title}
                  name="title"
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group as={Col} lg={3} controlId="title_en">
                <Form.Label>Titre (anglais)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="titre"
                  value={formData.title_en}
                  name="title_en"
                  onChange={handleChange}
                />
              </Form.Group>
{/* <Form.Group as={Col} md="5" controlId="category">
                            <Form.Label>Catégorie (requis)</Form.Label>
                            <Select
                                closeMenuOnSelect={true}
                                required 
                                options={[
                                    { value: 'included', label: 'Inclus' },
                                    { value: 'not-included', label: 'Non inclus' },
                                ]}
                                placeholder='Choisir la categorie...'
                                classNamePrefix="react-select"
                                value={formData.category}
                                onChange={value => { 
                                    setFormData(prev => ({
                                        ...prev,
                                        category: value
                                    }));
                                }}
                            />

                        </Form.Group> */}
              <Form.Group as={Col} lg={6} controlId="icon">
                <Form.Label>Icone</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Icone"
                  value={formData.icon}
                  name="icon"
                  onChange={handleChange}
                />
              </Form.Group>
              {formData.icon && <FontAwesomeIcon icon={formData.icon} />}


              <Form.Group as={Col} md="4" controlId="linkicon">
                <Form.Label>Lien d'icone</Form.Label>
                <Form.Control
                  type="text"
  
                  name="linkicon"
                  onChange={handleChange}
                  placeholder="Lien de l'image si pas d'icone"
                />
              </Form.Group>

              <Form.Group as={Col} lg={6} controlId="critereId">
                <Form.Label>Identifiant de critère  wordpress</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="ID WP critère"
                  value={formData.critereId}
                  name="critereId"
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>

            <div className="text-end">
              <Button variant="primary" type="submit" disabled={loading}>
                {!loading ? 'Mise à jour' : 'Chargement'}
              </Button>
            </div>
          </Form>
          <p>Vous pouvez rechercher un nom d'icon ici: <a target='_blank' href='https://fontawesome.com/icons'>https://fontawesome.com/icons</a></p>

        </Card.Body>
      )}
    </Card>
  );
};

export default EditService;
